<template>
  <div class="title-fiche" :class="typeItem">
    <div class="badge"></div>
    <h1><slot></slot></h1>
  </div>
</template>

<script>
  export default {
    props: ['typeItem']
  }
</script>

<style>

  .title-fiche {
    border: 3px dashed #ccc;
    border-radius: 25px;
    padding: 20px 20px 20px 100px;
    margin-bottom: 40px;
    position: relative;
  }
  .title-fiche h1 {
    font-size: 36px;
    color: #413492;
    letter-spacing: 1px;
    line-height: 41px;
    margin: 0;
   }
  .title-fiche .badge {
    display: inline-block;
    background: #de2128;
    border: 4px solid #7f0004;
    width: 100px;
    height: 100px;
    border-radius: 150px;
    color: white;
    font-size: 38px;
    margin-top: -50px;
    text-align: center;
    padding: 18px;
    position: absolute;
    left: -20px;
    top: 50%;
  }
  .title-fiche .badge:before {
    content: "\f02d";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    font-weight: 900;
    position: relative;
  }
  
  .title-fiche.article .badge {  background: #086fab; border-color: #403592;  }
  .title-fiche.article .badge:before { content: "\f1ea"; }
  
  .title-fiche.video .badge {  background: #e3e039; border-color: #c2b81b;  }
  .title-fiche.video .badge:before { content: "\f144";color: #414141;}
  
  
</style>
